export const meetsMinimumLength = (text: string, minLength = 8): boolean => {
  return text.length >= minLength;
};

export const containsUppercase = (text: string): boolean => {
  return /[A-Z]/.test(text);
};

export const containsLowercase = (text: string): boolean => {
  return /[a-z]/.test(text);
};

export const containsNumber = (text: string): boolean => {
  return /\d/.test(text);
};

export const containsSpecialCharacter = (text: string): boolean => {
  return /[!@#$%^&*(),.?":{}|<>\-_=+[\];:'"`~/\\ ]/.test(text.trim());
};

export const hasNoLeadingOrTrailingSpaces = (text: string): boolean => {
  return text.trim() === text;
};
